import React from 'react';
export function FAQ() {
  return <section className="py-16 px-6 bg-white" data-id="element-47">
      <div className="max-w-2xl mx-auto" data-id="element-48">
        <h2 className="text-2xl font-extrabold text-gray-900 text-center mb-8" data-id="element-49">
          ❓ Preguntas Frecuentes
        </h2>
        <div className="space-y-4" data-id="element-50">
          {[{
          q: '¿Cómo recibo el Pack de Inglés después de comprar?',
          a: 'Inmediatamente después del pago recibís un email con el link de descarga. En menos de 5 minutos tenés todo en tu computadora o celular.'
        }, {
          q: '¿Sirve para mi provincia?',
          a: 'Sí. El material está alineado al Marco Común Europeo de Referencia (MCER) y a los lineamientos curriculares nacionales vigentes, aplicables en todo el país.'
        }, {
          q: '¿Está en blanco y negro?',
          a: 'Sí. Todos los tomos están diseñados para ser fotocopiados en blanco y negro sin perder calidad ni legibilidad.'
        }, {
          q: '¿Los 6 bonus están en todas las ofertas?',
          a: 'Sí. Los 6 bonus estratégicos están incluidos en las tres opciones: Primaria, Secundaria y Pack Completo.'
        }, {
          q: '¿Los Ebooks Élite están en todas las ofertas?',
          a: 'Los 2 Ebooks Élite (Planificaciones Anuales + Banco de Exámenes) están incluidos únicamente en el Pack Completo.'
        }, {
          q: '¿Puedo comprar Primaria ahora y Secundaria después?',
          a: 'Sí. Cada opción es independiente. Aunque si después comprás Secundaria vas a pagar más que si llevás el Pack Completo ahora.'
        }, {
          q: '¿Está actualizado al currículo vigente?',
          a: 'Sí. El material está alineado al Diseño Curricular 2026 y al Marco Común Europeo de Referencia.'
        }, {
          q: '¿Qué pasa si no tengo internet en la escuela?',
          a: 'No necesitás internet en el aula. Descargás todo, lo imprimís y listo. El material es 100% offline.'
        }, {
          q: '¿Tiene garantía real?',
          a: 'Sí. 7 días de garantía total. Si no quedás satisfecha, te devolvemos el 100% sin preguntas.'
        }, {
          q: '¿Qué diferencia tiene con otros packs que vi?',
          a: 'Este material fue creado específicamente para la realidad del aula argentina, con guía docente en español, actividades graduadas por nivel MCER y solucionario incluido. No es traducción de material extranjero ni contenido genérico.'
        }].map(faq => <details key={faq.q} className="border border-gray-200 rounded-xl p-4 cursor-pointer group" data-id="element-51">
              <summary className="font-semibold text-gray-900 text-sm list-none flex justify-between items-center" data-id="element-52">
                {faq.q}
                <span className="text-blue-600 ml-2" data-id="element-53">+</span>
              </summary>
              <p className="mt-3 text-gray-600 text-sm" data-id="element-54">{faq.a}</p>
            </details>)}
        </div>
      </div>
    </section>;
}